import React from 'react'

import RolesPermissionsItem from 'views/RolesPermissions/Item'

import { TRoleWithPermissions } from 'types/roles'
import { EXCLUDED_APP_TYPES } from 'resources/roles'

type TProps = {
  roles: TRoleWithPermissions[]
}

const RolesPermissionsList = ({ roles = [] }: TProps) => {
  // exclude roles with specific app_type
  const filterRolesByAppType: TRoleWithPermissions[] = roles?.filter(
    (role) => !EXCLUDED_APP_TYPES.includes(role?.appType as string)
  )

  return (
    <div className="item-list">
      {filterRolesByAppType?.map(({ name, uuid, permissions }) => (
        <React.Fragment key={uuid}>
          <RolesPermissionsItem name={name} permissions={permissions} uuid={uuid} />
        </React.Fragment>
      ))}
    </div>
  )
}

export default RolesPermissionsList
